/* eslint-disable no-alert */
/* eslint-disable consistent-return */
// 面包屑中的 “添加管理员” 是活的  需要从VUEX中获取  切记
// 需要在VUEX中定义一个变量，添加时为false，修改时为true  修改是用户账号是不允许改的
// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)

export default {
  data() {
    return {
      username: '',
      password: '',
      again_password: '',
    };
  },
  computed: {
    adminparam() {
      return this.$store.state.admin.admineditinfo;
    },
  },
  methods: {
    // 返回方法
    adminReturn() {
      this.$router.push({
        path: '/admin', // 这是路由名称
      });
    },
    // 提交添加/修改方法，提交之前需要判断提交的数据是否合法
    adminUpdate() {
      const strRule = /^[\u4e00-\u9fa5]+$/; // 正则   是否是汉字  true汉字
      if (strRule.test(this.username)) {
        alert('管理员账号不能包括汉字');
        return false;
      } else if (this.password.length < 6) {
        alert('密码不能少于六位');
        return false;
      } else if (this.password != this.again_password) {
        alert('两次密码输入不一致');
        return false;
      } else if (this.password == '') {
        alert('账号不能为空');
        return false;
      } else if (this.username == '') {
        alert('密码不能为空');
        return false;
      }
      const self = this;
      axios({
        method: 'post',
        url: '/admin/admin/adminUpdate',
        data: { username: self.username, password: self.password },
      })
        .then((response) => {
          if (response.data.code == 1) {
            alert('操作成功');
            self.$router.push({
              path: '/admin', // 这是路由名称
            });
          } else {
            alert('操作失败');
          }
        })
        .catch((response) => {
          alert('请求失败');
        });
    },
  },
};
